<script>
import { user } from "./userStore.js";
import { toHSL } from "./util.js";

import TaskChat, { sendMessage } from "./TaskChat.svelte";
import TipCard from "./TipCard.svelte";
import confetti from "./confetti.min.js";
import Monaco from "./Monaco.svelte";
import { md5 } from "./util.js";
import Modal from "./Modal.svelte";
import {send, receive} from './crossfade.js';
import { slide, fade } from 'svelte/transition';


import Icon from "fa-svelte";
import { faCheckSquare } from "@fortawesome/free-solid-svg-icons/faCheckSquare";
import { faChalkboardTeacher } from "@fortawesome/free-solid-svg-icons/faChalkboardTeacher.js";
import { faCircle } from "@fortawesome/free-solid-svg-icons/faCircle";


export let task;
export let collapsed = false;
export let expanded = false;
export let check = false;
export let done = false;
export let inaccessible = false;
export let notcompleted = false;
export let tipsForTask = [];

let firstContentChanged;

let doneAnimation = false;

let editorLoadedVar = false;
//let taskIdFromParam = undefined;
let promise = Promise.resolve([]);
let showModalCheckResult = false;

let processingcode = "";
let javacodeFileMain = "";

let showEditor = false;

function toggleEditor(event) {
  showEditor = !showEditor;
  if (!showEditor && event) {
    console.log('saved');
    let code = event.detail.text;
    if (code) saveCodeInLocalStorage(code);
  }
  if (showEditor) {
    console.log('try processingcode: ' + $user.currentTask.processingcode);
    console.log('try javacodeFileMain: ' + $user.currentTask.javacodeFileMain);
    if ($user.currentTask && $user.currentTask.processingcode && !firstContentChanged) {
        processingcode = $user.currentTask.processingcode;
        // window.editor.setValue($user.currentTask.processingcode);
    } else {
      processingcode = "";
    }

    if ($user.currentTask && $user.currentTask.javacodeFileMain && !firstContentChanged) {
        javacodeFileMain = $user.currentTask.javacodeFileMain;
        // window.editor.setValue($user.currentTask.processingcode);
    } else {
      javacodeFileMain = "";
    }        
  }
}

function setTaskDone() {
    user.setTaskDone(task);
  $user.currentTask = null;

    doneAnimation = true;
    confetti.start();
    setTimeout(() => {
      doneAnimation = false;
      confetti.stop();
    }, 1000);
}

function setTaskCheck() {
  user.setTaskCheck(task);
  $user.currentTask = null;

  doneAnimation = true;
  confetti.start();
  setTimeout(() => {
    doneAnimation = false;
    confetti.stop();
  }, 1000);
}

function closeTaskWindow() {
  $user.currentTask = $user.currentTask.id === task.id ? null : task;
}

function submitSketch(event) {
  //closeTaskWindow();
  let code = event.detail.text;
  if (code) saveCodeInLocalStorage(code);  // скорей всего не надо, так как сохраняет при закрытии редактора
  let link = getLink(code, (newLink, resultLink, isOk) => {
    if (!isOk) {
      alert('error while saving code...');
      return;
    }
    let dontIncreaseUnreadFromStudent = task.button == "done";
    sendMessage("Задание выполнено: " + "<a href='" + newLink + "' target=_blank>" + newLink + "</a>", dontIncreaseUnreadFromStudent);
    switch (task.button) {
      case "check":
        setTaskCheck();
        break;
      case "stop":
        setTaskCheck();
        break;
      case "done":
        setTaskDone();
        break;
      default:
        alert('Task type error');
    }
    console.log('saved');
  });
}

function getLink(code, cb) {
    // showGistWindow();
    // document.getElementById('span_show_progress').innerHTML = "Подождите... Идет сохранение...";
    // document.getElementById('span_show_progress').style.display = "block";
    // document.getElementById('a_gist_url').style.display = "none";

    var userNameOrAnon = window.id_current_user_name && window.id_current_user_name != '{'+'{current_user.name}'+'}' ? window.id_current_user_name : "Anonymous";
    var authorName = "Автор: " + userNameOrAnon;
    console.log("userNameOrAnon " + userNameOrAnon);
    console.log("window.id_current_user_name " + window.id_current_user_name);
    
    // var code = document.getElementById('code');
    // var codeValue = window.editor.getValue();
    var dataObj = {
        description: authorName,
        files: {
            "file1.txt": {
                content: code
            }
        }
    };

    var posting = jQuery.post('https://us-central1-khasangchat.cloudfunctions.net/saveTryJavaCode', dataObj);
    posting.done(function( response ) {
      console.log('ID: ' + response.id);

      var isProfCodingMode = "&prof=true";
      var newParams = "?id=" + response.id + isProfCodingMode;

      var newLink = "https://khasang.io/p/processing" + newParams;
      var resultLink = "https://khasang.io/p/result" + newParams;

      cb(newLink, resultLink, true);
    });

    posting.fail(function(xhr, status, error) {
      let e = 'ERROR SENDING: ' 
          + ' ' + status + ' ' + error + ' ' + xhr.responseText;
      console.log(e);
      cb("", "", false);  
    });

    // JQuery.ajax({
    //     url: 'https://us-central1-khasangchat.cloudfunctions.net/saveTryJavaCode',
    //     type: 'POST',
    //     data: dataObj
    // }).done(function (response) {
    //     console.log('ID: ' + response.id);

    //     var isProfCodingMode = "&prof=true";
    //     var newParams = "?id=" + response.id + isProfCodingMode;

    //     var newLink = "https://khasang.io/p/processing" + newParams;
    //     var resultLink = "https://khasang.io/p/result" + newParams;

    //     cb(newLink, resultLink, true);

    //     // document.getElementById('a_gist_url').href = resultLink;
    //     // document.getElementById('a_gist_url').innerHTML = resultLink;
    //     // document.getElementById('a_gist_url').style.display = "block";
    //     // document.getElementById('span_show_progress').style.display = "none";
    //     // document.getElementById('a_gist_url_input').value = newLink;
    //     // document.getElementById('a_gist_window').style.display = "block";
    //     // changeURL(newParams);
    //     /*window.open(response.html_url);*/
    // }).error(function (e) {
    //     console.log(e);
    //     cb("", "", false);
    //     // document.getElementById('span_show_progress').innerHTML = "Сожалеем, произошла ошибка при сохранении";
    //     // document.getElementById('span_show_progress').style.display = "block";
    // });
}    

function saveCodeInLocalStorage(code) {
  // let code = window.editor.getValue();  
  localStorage.setItem(task.id, code);
}

function editorLoaded() {
  editorLoadedVar = true;
  let code = localStorage.getItem(task.id);
  if (code && code != "null") {
      window.editor.setValue(code);
      firstContentChanged = true;      
  }
}

// CHECK CODE
  async function fetchCheckCode() {
    let code = window.editor.getValue();
    let junit = task.junit;

    const response = await fetch("https://onlineju.herokuapp.com/api/v2/ju/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        files: [{
            name: "Main",
            content: code
            }],
        junit: junit
      })
    });

    if (response.ok) {
      return response.json();
    } else {
      throw new Error(
        "Упс, ошибка :( Похоже сервер не доступен. \nПопробуйте позже"
      );
    }
  }

  async function checkCode() {
    if (!task.id) return; // не подгрузилась задача
    window.editor.getAction('editor.action.formatDocument').run()
        .then(async () => {
        promise = fetchCheckCode();
        showModalCheckResult = true;
        let res = await promise;
        console.log(JSON.stringify(res, null, 2))
        if (res) saveCodeInLocalStorage(window.editor.getValue());
        if (res) postResultToDB(res);
        if (res) user.increaseCheckAttemptsCount(task);
    });
  }

  function postResultToDB(res) {
    let code = window.editor.getValue();
    let taskId = task.id;

    let userEmail = user.getUserEmail() || "undef";

    let result = res;
    result["user_name"] = user.getUserName() || "undef";
    result["user_email"] = userEmail;
    result["user_id"] = user.getUserId();
    result["timestamp"] = Date.now();
    result["code"] = code;
    result["task_name"] = task.name;
    result["task_id"] = taskId;

    // let student = {
    //     name: user.name || "undef",
    //     email: userEmail,
    //     timestamp: Date.now()
    // };

    // let task2 = {
    //     name: task.name,
    //     id: taskId,
    //     timestamp: Date.now()
    // };

    // if (result.ok) {
    //     task2['passed'] = true;
    //     student['passed'] = true;
    // }
    
    // let studentUid = md5(user.email);
    let studentUid = user.getUserId();
    let path = "/edulearn/tasks/checkbyuserbytask/";
    let path2 = "/edulearn/tasks/checkbyuser/";
    let resultChild = path + studentUid + "/" + taskId + "/";
    let resultChild2 = path2 + studentUid + "/";
    firebase.database().ref(resultChild).push(result);
    firebase.database().ref(resultChild2).push(result);

    // var newResultKey = firebase.database().ref(resultChild).push().key;
    // var updates = {};
    // updates[resultChild + newResultKey] = result;
    // firebase.database().ref().update(updates);

    // updates[path + "students/" + studentUid] = student;
    // updates[path + "tasks/" + taskId] = task2;
    // updates[path + "tasksbystudent/" + studentUid + "/" + taskId] = task2;
    // updates[path + "studentsbytask/" + taskId + "/" + studentUid] = student;
  }

  async function closeModalCheckResult() {
    showModalCheckResult = false;
    let res = await promise;
    if (res.ok) {
      // closeTaskWindow();      
      switch (task.button) {
        case "check":
          setTaskCheck();
          break;
        case "stop":
          setTaskCheck();
          break;
        case "done":
          setTaskDone();
          break;
        default:
          alert('Task type error');
      }      
    }  
  }
</script>

<style>
  .task h3 {
    margin: 0;
    font-size: 16px;
    font-weight: 100;
    /* text-transform: uppercase; */
    /* font-weight: 100; */
    /* color: #ccc; */
  }

  .card.expanded h3 {
    /* font-weight: bold; */
    text-transform: uppercase;
    /* color: #aaa; */
    /* color: #333; */
    color: #fff;
    /* font-weight: 100; */
    font-weight: 200;
    padding: 15px;
    font-size: 27px;
  }

  .card.expanded .tips h3 {
    margin: 0;
    text-transform: uppercase;
    font-weight: 100;
    color: #ccc;    
    font-size: 27px;
  }

  .card.task {
    /* background-color: burlywood; */
    background-color: #fff;
    /* color: #fff; */
  }

  /* .card.task.expanded { */
  /* background-color: {task.name != null && toHSL(task.name)}" */
  /* style="background-color: {chat.user !== $user && toHSL(chat.user)}" */
  /* } */

  .card.task.done {
    /* background-color: rgb(0, 163, 0); */
    /* background-color: #eee; */
    background-color: #fff;
    /* color: #bbb; */
    /* box-shadow: none; */
    /* color: transparent; */
    color: #fff;
    text-shadow: 0 0 0 #bbb;
    /* text-shadow: 0 0 0 rgb(27, 27, 27); */
    /* text-decoration: line-through; */
    /* opacity:0.3; */
  }

  .card.task.check {
    /* background-color: hsl(143, 41%, 90%); */
    /* color: hsl(143, 34%, 54%); */
    background-color: #fff;
    /* color: #bbb; */
    color: transparent;
    text-shadow: 0 0 0 #bbb;
  }

  .card.task.inaccessible {
    /* background-color: #eee; */
    background-color: #fff;
    /* color: #ddd; */
    box-shadow: none;
    border: dotted #bbb 1px;
    color: transparent;
    text-shadow: 0 0 0 #ddd;
  }

  .card {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
    /* transition: 0.8s; */
    /* transition: all 0.3s; */
    display: inline-block;
    vertical-align: top;
    margin: 10px;
    max-width: 200px;
    /* padding: 15px; */
    border-radius: 10px;
    position: relative;
    color: #fff;
  }

  .card.collapsed {
    padding: 15px;    
  }

  .card.expanded {
    /* position: absolute;
    z-index: 1; */

    width: 100%;
    /* height: 100%; */
    top: 0;
    margin-top: 0;
    left: 0;
    margin-left: 0;
    max-width: 100%;
    /* max-width: 70%; */
    /* border-radius: 20px; */
    /* border-radius: 20px 0px 20px 20px; */
    border-radius: 20px 20px 20px 20px;
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.5);
    /* transition: all 0.5s; */
  }

  .card.task.expanded .content {
    padding: 20px;
    text-align: left;
  }

  .card.task.fon {
    background: #fff;
    right: -30px;
    bottom: -30px;
    width: 100%;
  }

  /* On mouse-over, add a deeper shadow */
  .card:hover:not(.expanded):not(.tip):not(.inaccessible) {
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
    top: -1px;
    transition: all 0.5s;
    /* border-style: dashed; */
    /* background-color: #eeeeaa */
    /* background: burlywood; */
  }

  /* :global(.card.task.expanded) { */
    /* background: burlywood; */
    /* height: 300px; */
    /* background: #0f0; */
  /* } */

  /* Add some padding inside the card container */
  .container {
    /* padding: 2px 16px; */
    padding: 2px;
  }

  /* :global(.container.bold) { */
  .container.bold {
    /* font-weight: bold; */
    text-transform: uppercase;
    /* color: #aaa; */
    /* color: #333; */
    color: #fff;
    /* font-weight: 100; */
    font-weight: 200;
    padding: 15px;
    font-size: 27px;
  }

  button.playground {
    color: #fff;
    /* background-color: coral; */
    /* color: coral; */
    /* background-color: rgb(201, 84, 42); */
    background-color: #f0ad4e;
    border: 0;
    padding: 10px;
    margin: 30px;
    text-transform: uppercase;
    /* border-radius: 5px; */

    /* border-radius: 0 0 20px 20px; */
    border-radius: 5px;
    /* position: absolute;
    right: -30px;
    bottom: -30px;
    width: 100%; */
  }

  button.helpme {
    background-color: rgb(212, 212, 212);
    border: 0;
    padding: 10px;
    /* margin: 30px; */
    border-radius: 5px;
    color: rgb(129, 129, 129);
    text-transform: uppercase;
    font-size: 12px;
  }

  button.done {
    /* background-color: green; */
    background-color: orange;
    border: 0;
    padding: 10px;
    margin: 30px;
    /* border-radius: 5px; */
    border-radius: 0 0 20px 20px;
    color: #fff;
    text-transform: uppercase;
    position: absolute;
    right: -30px;
    bottom: -30px;
    width: 100%;
    /* width: 70%; */
    /* bottom: 0px; */
  }

  button.check {
    background-color: green;
    border: 0;
    padding: 10px;
    margin: 30px;
    border-radius: 0 0 20px 20px;
    color: #fff;
    text-transform: uppercase;
    position: absolute;
    right: -30px;
    bottom: -30px;
    width: 100%;
  }

  button.cancel {
    /* background-color: green; */
    background-color: orange;
    border: 0;
    padding: 10px;
    margin: 30px;
    /* border-radius: 5px; */
    border-radius: 0 0 20px 20px;
    color: #fff;
    text-transform: uppercase;
    position: absolute;
    /* right: -30px; */
    left: -30px;
    bottom: -30px;
    width: 20%;
    /* bottom: 0px; */
  }

  button.close-task {
    /* background-color: green; */
    background-color: hsl(39, 60%, 80%);
    border: 0;
    padding: 10px;
    margin: 30px;
    /* border-radius: 5px; */
    border-radius: 0 0 20px 20px;
    color: #fff;
    text-transform: uppercase;
    position: absolute;
    /* right: -30px; */
    right: -30px;
    top: -30px;
    /* width: 20%; */
    /* bottom: 0px; */
  }

  button.hidden {
    visibility: hidden;
    /* display: none; */
  }

  .left-info {
    width: 100%;
    height: 100%;
    top: 0;
    margin-top: 0;
    position: absolute;
    left: 0;
    margin-left: 0;
    border-radius: 0;
    background: #0f0;
    display: inline-block;
    padding-top: 20px;
    max-width: 200px;
  }

  :global(.myClass1) {
    /* color: red; */
    position: relative;
    top: 1px;
  }

  :global(.myClass2) {
    font-size: 14px;
  }

  div.hw {
    text-align: left; 
    background-color: #fff; 
    padding: 20px; 
    /* margin: 0px;  */
    /* border-radius: 10px 10px 0px 0px; */
    margin: -15px; 
    border-radius: 0px 0px 20px 20px;
  }

  input.hw {
    width: 100%;
    height: 40px;
    padding: 5px 10px;
    /* background-color: rgb(215, 215, 215); */
    line-height: 20px;
    font-size: 12px;
    /* color: rgb(136, 136, 136); */
    border-radius: 3px 3px 3px 3px;
    border: 1px solid rgb(114, 114, 114);
    box-shadow: 0 1px 0 rgba(24, 24, 24, 0.1);
    box-sizing: border-box;
  }  

  .chat-container {
		/* border-top: 1px solid #333; */
		/* border-bottom: 1px solid #333; */
		min-height: 200px;
		/* height: calc(100vh - 15em); */
		height: calc(100vh - 35em);
	}

  .editorLoading {
    /* display: block; 
    position: fixed; 
    z-index: 100; 
    left: 100px;
    right: 100px;
    top: 50px;
    bottom: 50px;
    background-color: #272822;
    color: #fff;
    padding: 50px; */

    display: block; 
    position: fixed;
    z-index: 100;
    width: 90%;
    height: 85%;
    top: 5%;
    margin-top: 0;
    left: 5%;
    margin-left: 0;
    max-width: 100%;        

    background-color: #272822;
    color: #fff;    
  }

.badge {
  display: inline-block;
  min-width: 10px;
  padding: 3px 7px;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  background-color: #777;
  border-radius: 10px;
}

.badge.unread {
  /* display: block; */
  position: absolute;
  top: -5px;
  left: -5px;
  background-color: red;
}
</style>

    <!-- in:receive="{{key: task.id}}" out:send="{{key: task.id}}" -->
<div
    class="card task"
    class:check
    class:done
    class:inaccessible
    class:collapsed
    class:expanded
    on:click={() => {
      if (!inaccessible) { 
        $user.currentTask = task;
        if (!expanded) user.resetUnreadFromTeacher(task);
      }
    }}
    style="background-color: {notcompleted ? task.bgcolor : ''} ; color: {done ? task.bgcolor : ''}; "
    >
    <!-- style="background-color: {notcompleted || done ? task.bgcolor : ''}; " -->
    <!-- //task.done = !task.done;  -->
    <!-- border-top: {done ? '1px solid ' + task.bgcolor : ''}; -->
    <!-- border: {done ? '1px solid ' + task.bgcolor : ''}; -->
    <!-- <h3>{#if task.done}✅ {/if}{task.name}</h3> -->
    <!-- <h3 in:receive="{{key: 'h3'}}" out:send="{{key: 'h3'}}">{task.name}</h3> -->
    <h3>{task.name}</h3>
    {#if task.unreadFromTeacher}
      <span class="badge unread">{task.unreadFromTeacher}</span>
    {/if}
    {#if expanded}
      <br />
      <div class="content">
       {@html task.desc}
      </div> 
      <br />
      <!-- {#if !task.check && !task.done} -->
      {#if !task.check}
        <button
          class="playground"
          class:hidden={task.type != "processing" && task.type != "java"}
          on:click|preventDefault|stopPropagation={() => {
            toggleEditor();
          }}>
          <!-- <Icon class="myClass1 myClass2" icon={faChalkboardTeacher} />             -->
          ☕️Открыть редактор кода
        </button>
      {/if}

      <!-- <button
        class="close-task"
        on:click|preventDefault|stopPropagation={() => {
          $user.currentTaskId = $user.currentTaskId === task.id ? null : task.id;
        }}>
        X
      </button> -->
      <div style="position: absolute; right: 17px; top: 18px;">
        <a on:click|preventDefault|stopPropagation={closeTaskWindow}
        href="none" class="closeButton">&nbsp;</a>
      </div>

      <!-- <div class="hw"> -->
      <!-- {#if currentTask.hw} -->
        <!-- <TaskChat taskId={currentTask.id} userId={user.getUserId()} from={"student"}/> -->
        <!-- <button on:click="{()=>{task.link_from_student && sendMessage(task.link_from_student); task.link_from_student = ""}}">send</button> -->
        
        <!-- -M7KuuORNvDzTP3TJItg -->
        <!-- <div class="container bold">Сданные решения</div> -->
        <!-- <div style="text-align: left">
          {#each Object.values(currentTask.hw) as hw}
          {hw}<br>
          {/each}
        </div> -->

        <!-- <div class='chat-container'>
          <VirtualList items={Object.values(currentTask.hw)} let:item autoscroll={true}>
            <ChatItem {item}/>
          </VirtualList>
        </div> -->

      <!-- {/if} -->
      <br />
      <!-- <label>          
      <input class="hw" bind:value={task.link_from_student} placeholder="https://вставьте сюда ссылку на выполненное задание"/>
      </label> -->
      <br><br><br>
      <!-- <br><br> -->

      <!-- {#if Math.random() >= 0.5} -->
      <!-- <button
        class="helpme"
        on:click|preventDefault|stopPropagation={() => {
          setTaskPleaseHelp(task);
        }}>
        <i class="fas fa-chalkboard-teacher" />
        Не знаю, как решить 😱Помогите
      </button>           -->
      <!-- </div>           -->

      <!-- // МОЖНО УБРАТЬ, ТЕПЕРЬ ЗАДАНИЕ СДАЕТСЯ ЧЕРЕЗ МОНАКО -->
      <!-- {#if !task.check && !task.done}
        {#if task.button == 'check'}
          <button
            class="check"
            on:click|preventDefault|stopPropagation={() => {
              setTaskCheck();
            }}>
            <Icon class="myClass1 myClass2" icon={faCheckSquare} />
            Отправить задачу на проверку
          </button>
        {/if} -->
        <!-- {#if !task.button || task.button == 'done'}
          <button
            class="done"
            on:click|preventDefault|stopPropagation={() => {
              setTaskDone();
            }}>
            <Icon class="myClass1 myClass2" icon={faCheckSquare} />
            Отметить задачу выполненной
          </button>
        {/if}
      {/if} -->

      <!-- <div class="fon"> -->
      <div class="tips" style="background: #fff;
          border-radius: 0 0 20px 20px;
          right: -30px;
          bottom: -30px;
          width: 100%;">
        <br />
        {#if tipsForTask.length > 0}
          <h3>Посмотрите подсказки</h3>
        {/if}
        <br />
        {#each tipsForTask as tip, i (tip.id)}
            <TipCard bind:tip/>
        {/each}
        <br /><br />

        <!-- <h3>Спросите преподавателя</h3> -->
        <h3>Code Review</h3>
        <TaskChat {task} userId={user.getUserId()} from={"student"}/>
        <br>
        <!-- <h3>История ваших решений</h3>
        <br><br> -->
      </div>
    {/if}
</div>

  <!-- {#if $user.currentTaskId && notCompletedTasks.includes(currentTask)}
    <br><br>
    <button
      class="helpme"
      on:click|preventDefault|stopPropagation={() => {
        setTaskPleaseHelp(currentTask);
      }}>
      <i class="fas fa-chalkboard-teacher" />
      Подсказок не хватает... <br>Не знаю, как решить 😱Помогите 💭
    </button>        
  {/if}   -->

{#if showEditor}
<!-- <div style="text-align:left" transition:fade> -->
<div style="text-align:left">
  <Monaco on:close={toggleEditor} 
    on:loaded={editorLoaded} 
    on:submitSketch={submitSketch}
    bind:firstContentChanged={firstContentChanged}
    on:checkCode={checkCode}
    bind:task={task}
    {processingcode}
    {javacodeFileMain}
    bind:type={task.type}
    bind:taskDone={task.done}
    bind:taskCheck={task.check}/>
    <!-- processing=currentTask.processing/> -->
  {#if !editorLoadedVar}
    <div class="editorLoading">
    <div style="text-align: center; vertical-align: middle; height: 100%"><br><br><br><br><br><br>Редактор загружается... </div>
    </div>
  {/if}  
</div>
{/if}

{#if showModalCheckResult}
  <Modal on:close={async () => closeModalCheckResult()}>
    {#await promise}
    <div>
      <p>...waiting</p>
    </div>
    {:then result}
    <!-- <div transition:fade> -->
    <div>
      <!-- <h2 slot="header"> -->
        {#if result.ok}
          <h2><span style="color: #109520">✅ ЗАДАЧА ВЫПОЛНЕНА!</span></h2>
          <button class="playground" on:click={async () => closeModalCheckResult()}>OK</button>
          <!-- Название выполненной задачи: {task.name} -->
          <!-- <br><br> -->
          <!-- (Нажмите в любом месте экрана, чтобы открылись следующие задачи) -->
            <!-- Количество тестов: {result.testCount}<br>
            Пройдено тестов: {result.testCount - result.testFailed}<br>           -->
            <!-- Кол-во тестов не информативно -->
        {:else}
            {#if result.testCodeFailed}
              <h2><span style="color: #2f2090">💤Ошибка на стороне сервера</span></h2>
                Напишите, плз, в чат преподавателю<br>или на саппорт support@khasang.io
            {:else}
                <!-- <h2><span style="color: #ff0000">{getRandomSadSmile()} ЗАДАЧА ПОКА НЕ ВЫПОЛНЕНА</span></h2> -->
                <h2><span style="color: #ff0000">ЗАДАЧА ПОКА НЕ ВЫПОЛНЕНА</span></h2>
                {#if result.compileOutput}
                    <b>Результат компиляции:</b><br><br>
                    <!-- {@html result.compileOutput && result.compileOutput
                        .replace(/</g, '&lt;')
                        .replace(/>/g, '&gt;')
                        .replace(/\n/g, '<br>')
                        .replace(/\s/g, '&nbsp;')} -->
                    <span style="text-align: left">
                      <pre class="compileOutput">{result.compileOutput}</pre>
                      <pre class="compileOutput">{result.failureMessages}</pre>
                    </span>
                {:else}
                    Количество тестов: {result.testCount}<br>
                    Провалено тестов: {result.testFailed}<br>
                    <br>
                    {#if result.failureMessages}<b>Сообщения об ошибках:</b><br><pre>{result.failureMessages}</pre><br>{/if}
                {/if}          
            {/if}          
        {/if}
    </div>
    {:catch error}
      <p style="color: red">{error.message}</p>
    {/await}
  </Modal>
{/if}

<svelte:head>
  <script src="https://code.jquery.com/jquery-2.1.4.min.js"></script>
</svelte:head>